import { MDXComponents } from "@/components/MDXComponents/MDXComponents";
import { MDXRemote, type MDXRemoteSerializeResult } from "next-mdx-remote";

import * as styles from "./DocsMainContent.styles";

type Props = {
  mdxSource: MDXRemoteSerializeResult;
};

const DocsMainContent = ({ mdxSource }: Props) => {
  return (
    <section className="docs-content" css={styles.content} aria-label="Documentation content">
      <MDXRemote {...mdxSource} components={MDXComponents} />
    </section>
  );
};

export { DocsMainContent };
